module.exports = __webpack_public_path__ + "img/sbadge_h_active.c6a98047.svg";